import { z } from 'zod/v4';

import { applicationUserSchema } from './application-user.schema';

export const webApplicationSchema = z.object({
  applicationDisplayName: z.string(),
  applicationId: z.number(),
  applicationName: z.string(),
  internalUseOnly: z.boolean().optional(),
  users: z.array(applicationUserSchema).optional(),
});

export type WebApplication = z.infer<typeof webApplicationSchema>;
